


















  import { Vue, Component, Prop } from 'vue-property-decorator'

  @Component
  export default class OneCartModalDelete extends Vue {
    @Prop({
      type: Boolean,
      required: true,
    })
    value!: boolean;

    @Prop({
      type: Boolean,
      required: false,
      default: false,
    })
    progress!: boolean;

    onRemove() {
      this.$emit('confirmed', true)
    }
  }
